import Vue                       from 'vue'
import Router                    from 'vue-router'
import axios                     from 'axios'
import VueAxios                  from 'vue-axios'
import infiniteScroll            from 'vue-infinite-scroll'
import welcomeCustomerView       from '@/views/View_welcome_customer'
import newTicketView             from '@/components/New_Ticket_View'
import newTicketContratoView             from '@/components/New_Ticket_Contrato_View'
import TicketList                from '@/views/View_tickets'
import detalleTicketView         from '@/views/View_detalle_ticket'
import perfilUsarioView         from '@/views/View_user_profile'
import Notifications             from 'vue-notification'
import moment                    from 'moment'
import VueUpload                 from '@websanova/vue-upload'
import VueUploadHttp             from '@websanova/vue-upload/dist/drivers/http/axios.esm.js'
import goTo from 'vuetify/es5/services/goto'
import 'moment/locale/es'
moment.locale('es')

Vue.use(Notifications)
Vue.use(Router)
Vue.use(VueAxios, axios)
Vue.use(infiniteScroll)
Vue.use(VueUpload, {
  http: VueUploadHttp
})
Vue.axios.defaults.baseURL = process.env.API_ROUTE

export default new Router({
  mode: 'history',
  scrollBehavior: (to, from, savedPosition) => {
    let scrollTo = 0
    if (to.hash) {
      scrollTo = to.hash
    } else if (savedPosition) {
      scrollTo = savedPosition.y
    }

    return goTo(scrollTo)
  },
  routes: [
    { path: '/login', redirect: '/' },
    { path: '/register', redirect: '/profile' },
    {
      path     : '/',
      name     : 'welcome_customer',
      component: welcomeCustomerView
    },
    {
      path     : '/ticket/nuevo',
      name     : 'nuevo_ticket',
      component: newTicketView
    },
    {
      path     : '/ticket-contrato/nuevo',
      name     : 'nuevo_ticket_contrato',
      component: newTicketContratoView
    },
    {
      path     : '/tickets',
      name     : 'ticket_list',
      component: TicketList
    },
    {
      path     : '/ticket/:numero',
      name     : 'detalle_ticket',
      component: detalleTicketView,
      props    : true
    },
    {
      path     : '/profile',
      name     : 'profile',
      component: perfilUsarioView
    },
    {
      path     : '/profile-activate',
      name     : 'profile-activate',
      component: () => import('@/components/Verificar_email.vue')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/customer.js